<template>
  <div id="app_content" class="reserved">
    <div v-if="openDocs" @click="openDetail" class="overlay-docs">
    </div>
    <div v-if="openDocs" class="documenti">
      <modal_documenti
          v-if="currentDocId"
          :idDocumento="currentDocId.id_ordine"
          :numDocumento="currentDocId.n_ordine"
          :stato="currentDocId.stato"
          :data="currentDocId.data"
          :importo="currentDocId.importo"
          @closed="closeDetail"
      />
    </div>
    <div class="my-container">
      <div class="row">
        <div class="col-md-12">
          <h2>{{ trans.get('b2b.orders.my-orders') }}</h2>
        </div>
        <div class="col-md-6 col-lg-3">
          <select
              v-model="mese"
              @change="filterMese($event)"
              name="mese"
              id="mese"
              class="select-month"
          >
            <option :value="0">{{ trans.get('b2b.orders.month') }}</option>
            <option v-for="m in mesi" :value="m">
              {{ m }}
            </option>
          </select>
        </div>
        <div class="col-md-6 col-lg-3">
          <select
              v-model="anno"
              @change="filterAnno($event)"
              name="anno"
              id="anno"
              class="select-year"
          >
            <option :value="0">{{ trans.get('b2b.orders.year') }}</option>
            <option v-for="a in anni" :value="a">
              {{ a }}
            </option>
          </select>

        </div>
        <div class="col-md-6 col-lg-3 resetta">
          <a class="my-btn btn green text-black" @click="getOrdini">{{ trans.get('b2b.orders.reset-filter') }}</a>
        </div>

        <div class="col-md-12">
          <label for="searchTxt">{{ trans.get('b2b.orders.order-no') }}</label>
        </div>
        <div class="col-md-12 search">
          <input
              type="text"
              v-model="searchTxt"
              name="searchTxt"
              id="searchTxt"
              @keyup="searchOrdini()"
          />
        </div>
      </div>

      <div class="row intestazione">
        <div class="col-md-3">{{ trans.get('b2b.orders.document-no') }}</div>
        <div class="col-md-2 col-lg-3">{{ trans.get('b2b.orders.date') }}</div>
        <div class="col-md-2 col-lg-3">{{ trans.get('b2b.orders.status') }}</div>
        <div class="col-md-5 col-lg-3">{{ trans.get('b2b.orders.price') }}</div>
      </div>
      <div class="row">
        <b-skeleton size="is-large" height="44px" :active="!isLoaded"></b-skeleton>
        <div class="col-md-12 dati">
          <det_ordini

              @openDoc="openDetail"
              v-for="(o, k) in ordini_filtered"
              :key="k"
              :chiave="k"
              :n_ordine="numeroOrdine(o)"
              :id_ordine="o.idDocumento"
              :data_ordine="o.dataRegistrazione"
              :stato_ordine="statoOrdine(o.stato)"
              @year="fetchDatesY"
              @month="fetchDatesM"
              :totale_ordine="o.totDoc"
              :iva="o.totIvaDoc"
              @loaded="rigaLoaded"
              class="det_ordini"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import det_ordini from "./det-ordini";
import modal_documenti from './modal-documenti'

export default {
  name: "ordini",
  components: {
    det_ordini,
    modal_documenti
  },
  data() {
    return {
      isLoaded: false,
      ordini: null,
      ordini_filtered: null,
      openDocs: false,
      currentDocId: null,
      searchTxt: "",
      anni: [],
      mesi: [],
      mese: 0,
      anno: 0,
    };
  },
  mounted() {
    this.getOrdini();
  },

  watch: {
    searchTxt: function () {
      if (this.searchTxt === '') {
        this.getOrdini()
      } else {
        this.searchOrdini()
      }
    },
  },

  methods: {

    statoOrdine (s) {
      switch (s){
        case 'Ordinato':
        return {stato: 0, testo: this.$trans('b2b.personal-area.ordered')}
        case 'Completato':
          return {stato: 1, testo: this.$trans('b2b.personal-area.completed')}
        case 'Residui':
          return {stato: 2, testo: this.$trans('b2b.personal-area.residues')}
      }
    },

    numeroOrdine: function (o) {
      return o.dataRegistrazione.split('-')[0]+'-'+o.codSerie+'-'+o.numRegistraz;
    },

    rigaLoaded: function (value) {
      if (value === this.ordini_filtered.length -1){
       // console.log(true)
        this.isLoaded = true
      }
    },

    openDetail: function (value) {

      this.currentDocId = value
      this.openDocs = !this.openDocs
    },
    closeDetail: function () {
      this.openDocs = false
    },
    filterMese: function (event) {
      // if (this.mese === 0) {
      //   this.getOrdini();
      // } else {

      let mese = this.mese;

      let result = this.ordini_filtered.filter((item) => {
        let meseReg = dayjs(item.dataRegistrazione).month() + 1;

        return meseReg === mese;
      });

      if (result.length > 0) {
        this.ordini_filtered = result;
      }
      let self = $('#mese')
     self.prop('disabled', true)
      // }
    },
    filterAnno: function (event) {
      // if (this.anno === 0) {
      //   this.getOrdini();
      // } else {

      let anno = this.anno;
      let result = this.ordini_filtered.filter((item) => {
        let annoReg = dayjs(item.dataRegistrazione).year();
        return annoReg === anno;
      });

      if (result.length > 0) {
        this.ordini_filtered = result;
      }
      let self = $('#anno')
      self.prop('disabled', true)
    },

    fetchDatesY: function (value) {
      if (!this.anni.includes(value)) {
        this.anni.push(value);
      }
      this.anni = this.anni.sort(function (a, b) {
        return a - b;
      })
    },

    fetchDatesM: function (value) {
      if (!this.mesi.includes(value)) {
        this.mesi.push(value);
        this.mesi = this.mesi.sort(function (a, b) {
          return a - b;
        })
      }
    },

    searchOrdini: function () {
      if (this.searchTxt === "") {
        this.getOrdini();
        //console.log("vuoto");
      } else {

        let numSearch = this.searchTxt.replace(/(-| |_)/gi, '');

        let result = this.ordini.filter((item) => {
          return (
              item.numeroOrdine.replace(/-/gi, '').indexOf(numSearch) > -1
          );
        });

        if (result.length > 0) {
          this.ordini_filtered = result;
        } else {
          this.ordini_filtered = null;
        }
      }
    },
    getOrdini: function () {
      let mese = $('#mese')
      let anno = $('#anno')
      mese.prop('disabled', false)
      anno.prop('disabled', false)
      axios({
        method: "get",
        url: window.location.origin + "/b2b/orders",
      })
          .then((res) => {
            // Imposto una propietá custom all'oggetto ordine in modo da poter effettuare il filtraggio sul numero ordine
            for(let i in res.data) {
              res.data[i].numeroOrdine = this.numeroOrdine(res.data[i]);
            }
            this.ordini = res.data;
            this.ordini_filtered = this.ordini;

          })
          .catch((err) => {
            console.log(err.response.data.message);
          });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-black{
  color: #000;
}
.my-container{
  width: 80%;
  margin: 0 auto;
}
.reserved {
  .overlay-docs {
    width: 100vw;
    height: calc(100vh - 80px);
    background-color: rgba(0, 0, 0, .5);
    backdrop-filter: blur(20px);
    position: fixed;
    top: 80px;
    z-index: 10;
  }

  .documenti {
    position: fixed;
    width: 60vw;
    height: calc(100vh - 80px);
    top: 80px;
    right: 0;
    z-index: 11;
  }

}

h2 {
  font-size: 24px;
}

.select-month, .select-year {
  margin: 21px 0;
  width: 100%;
  padding: 6.5px;
  border: none;
  background-color: #eeeeee;
  -webkit-appearance: none;
  background-image: url("/media/icons/svg/caret-down-black.svg");
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: center;
}
.resetta  {
  display: flex;
  align-items: center;
}
.search {
  input {
    width: 100%;

    &:after {
      content: url("/media/icons/svg/icona-lente.svg");
    }
  }
}

.intestazione {
  margin-top: 40px;
  padding-left: 15px;
  display: none;
}

.dati {
  margin: 20px 0;

  .det_ordini {
    cursor: pointer;
  }
}

@media (min-width: 576px) {
  .search {
    input {
      width: 50%;
    }
  }
  .intestazione {
    display: flex;
  }

}

@media (min-width: 1200px) {
  .reserved{
    .container{
      width: 54%;
    }
  }

 }
</style>
